export const getPerfilUserService = (fetch) => async () => {
  try {
    const response = await fetch({ url: "/api/v2/get/perfil/user" });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
